import React, { useState } from "react";
import {
  OTPContainer,
  StyledDialogActions,
  Separator,
  ResendButton,
} from "./styles";
import { useSelector } from "react-redux";
import { useForgotVerifyEmailOtp, useForgotSendEmailOtp } from "../../../services/mutations";
import { toast } from "react-toastify";
import Button from "../../Button";
import CircularProgress from "@mui/material/CircularProgress";

export const OTPContent = ({ onVerifySuccess }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false)
  const [resendLoad, setResendLoad] = useState(false);

  const { userProfile } = useSelector((state) => state.userProfile);

  const sendEmailOtp = useForgotSendEmailOtp();
  const verifyOtp = useForgotVerifyEmailOtp();

  const handleChange = (value, index) => {
    if (!/^[0-9]*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      nextInput?.focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && otp[index] === "") {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      prevInput?.focus();
    }
  };

  const verifyCode = async() => {
    try {
      setLoading(true)
      const otpCode = otp.join("");
      if(otpCode.length < 6){
        toast.error("Please enter the complete OTP.");
        setLoading(false)
        return;
      }
      verifyOtp.mutateAsync(
        {
          email: userProfile.email,
          otp: otpCode,
        },
        {
          onSuccess: (response) => {
            toast.success("Your code is Verified!");
            setLoading(false)
            onVerifySuccess()
          },
          onError: (err) => {
            console.log(err);
            toast.error(err.response.data.message);
            setLoading(false);
          },
        }
      );
    } catch (err) {
      console.log("error in catch", err)
      toast.error(err.response.data.message);
      setLoading(false);
    }
  };

  const resendOtp = () => {
    try {
      setResendLoad(true);
      sendEmailOtp.mutate(
        {
          email: userProfile.email,
        },
        {
          onSuccess: (response) => {
            setResendLoad(false);
            toast.success("An otp has been resent to your email address!");
          },
          onError: (err) => {
            console.log(err);
            toast.error(err.response.data.message[0]);
            setResendLoad(false);
          },
        }
      );
    } catch (err) {
      toast.error(err.response.data.message[0]);
      setResendLoad(false);
    }
  }

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    const pastedOtp = pastedData.split("").slice(0, otp.length);

    if (pastedOtp.length > 0) {
      const newOtp = [...otp];
      pastedOtp.forEach((char, i) => {
        if (i < 6) {
          newOtp[i] = char;
        }
      });
      setOtp(newOtp);

      if (pastedOtp.length === 6) {
        document.getElementById(`otp-input-${pastedOtp.length - 1}`).focus();
      }
    }
  };

  return (
    <div>
      <div>
        Enter the verification code we just sent to your email address at{" "}
        {userProfile.email}
      </div>
      <OTPContainer>
        {otp.map((_, index) => (
          <input
            key={index}
            id={`otp-input-${index}`}
            type="text"
            maxLength="1"
            value={otp[index]}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onPaste={handlePaste}
          />
        ))}
      </OTPContainer>
      <Separator />
      <StyledDialogActions>
        {resendLoad ? (
          <CircularProgress size={20} style={{ color: "#495057", marginRight: "5px" }} />
        ) : (
          <ResendButton onClick={resendOtp}>Resend</ResendButton>
        )}
        <Button onClick={verifyCode} isLoading={loading} width={"auto"} disabled={otp.every((char) => char === "")}>
          Verify
        </Button>
      </StyledDialogActions>
    </div>
  );
};
